export default __webpack_public_path__ + "static/media/bill_smart.0727c51d.png";